<agr-page-toolbar [pageTitle]="'app.contactperson.navigation.relations' | translate">
  <ng-container actions>
    <agr-primary-action
      actionIcon="add"
      [actionText]="'add' | translate"
      (click)="addRelation()"
      onkeypress="addRelation()"
      data-test="relation__add"
    ></agr-primary-action>
  </ng-container>
</agr-page-toolbar>

<section class="spacing--padding-all">
  <ng-container [agrBlockSpinner]="(customersWithRelations$ | async) === undefined">
    @if (contactpersonId$ | async; as contactpersonId) {
      <div>
        @if ((customersWithRelations$ | async)?.length === 0) {
          <div class="wrapper--spacing-horizontal">
            <agr-notification-empty
              emptyTitle="{{ 'app.no_results_title' | translate }}"
              emptyDescription="{{ 'app.no_results_description' | translate }}"
              [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
            ></agr-notification-empty>
          </div>
        } @else {
          <mat-nav-list>
            @for (customer of customersWithRelations$ | async; track customer) {
              <a
                href="#"
                mat-list-item
                data-test="relations-overview__item"
                class="listItem"
                [routerLink]="['/contactperson', contactpersonId, 'relations', customer.id]"
              >
                <div matListItemTitle class="text--h6" data-test="relations-overview__name">
                  {{ customer.name }}
                </div>
                <div matListItemTitle class="text--small">
                  {{ customer.emailAddress }}
                  <span class="text--gray"
                    >{{ customer.street }} {{ customer.houseNumber }}
                    {{ customer.houseNumberAddition }} {{ customer.postalCode }}
                    {{ customer.city }} ({{
                      'app.countries.' + customer.country | translate
                    }})</span
                  >
                </div>
                <button matListItemMeta mat-icon-button (click)="$event.preventDefault()">
                  <mat-icon iconPositionEnd>edit</mat-icon>
                </button>
              </a>
            }
            <mat-divider></mat-divider>
          </mat-nav-list>
        }
      </div>
    }
  </ng-container>
</section>
